import AcumuladoCard from "./AcumuladoCard";

import { Grid } from "@mui/material";
import { getDashboardPeriodRange } from '../../../../helpers/admin/dashboard/dashboardHelper';

const Acumulado = ({
    today,
    dateRanges,
    todayTotalData, weekTotalData, monthTotalData, quarterTotalData, yearToDateTotalData
}) => {
    const range = period => getDashboardPeriodRange(period, today);

    return (
        <Grid container spacing={4} sx={{ mt: 2 }}>
            <AcumuladoCard
                dateRange={dateRanges.today}
                dateLabel={'Diario'}
                icon={'fa-solid fa-receipt'}
                totalSales={todayTotalData}
                exportRange={range('today')}
                exportFilename="pedidos_ventas_diarias.csv"
            />

            <AcumuladoCard
                dateRange={dateRanges.week}
                dateLabel={'Semanal'}
                icon={'fa-solid fa-coins'}
                totalSales={weekTotalData}
                exportRange={range('week')}
                exportFilename="pedidos_ventas_semanales.csv"
            />

            <AcumuladoCard
                dateRange={dateRanges.month}
                dateLabel={'Mensual'}
                icon={'fa-solid fa-cash-register'}
                totalSales={monthTotalData}
                exportRange={range('month')}
                exportFilename="pedidos_ventas_mensuales.csv"
            />

            <AcumuladoCard
                dateRange={dateRanges.quarter}
                dateLabel={'Trimestral'}
                icon={'fa-solid fa-hand-holding-dollar'}
                totalSales={quarterTotalData}
                exportRange={range('quarter')}
                exportFilename="pedidos_ventas_trimestrales.csv"
            />

            <AcumuladoCard
                dateRange={dateRanges.yearToDate}
                dateLabel={'Year to Date'}
                icon={'fa-solid fa-dollar-sign'}
                totalSales={yearToDateTotalData}
                exportRange={range('yearToDate')}
                exportFilename="pedidos_ventas_year-to-date.csv"
            />
        </Grid>
    );
};

export default Acumulado;
